import {
  React,
  Component,
  axios,
  routes,
  helpers,
} from 'imports/CommonImports';

import {
  Paper,
  SelectField,
  MenuItem,
  Divider,
  DatePicker,
} from 'material-ui';

import {
  PrimaryButton,
} from 'imports/DesignImports';

const stepToTitle = {
  'postulation': 'Postulación',
  'selection': 'Selección',
  'files': 'Fichas',
}

const styles = {
  paper: {
    padding: '1em'
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginRight: '1em',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1em',
  },
  tutorialTitle: {
    fontWeight: '700',
    fontSize: '1em'
  },
  inputContainer: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '50%',
    fontWeight: 'normal',
  },
  dateInput: {
    cursor: 'pointer',
    marginLeft: '1em',
    fontWeight: '300',
  }
}

class ChangeCompanyDeadlines extends Component {
  constructor(props){
    super(props);
    this.state = {
      selectedCompany: props.companies[0],
      token: this.props.cookies.get('token'),
      dateNow: new Date(Date.now),
      data: props.companies[0].deadlines,
    }
  }
  render() {
    return (
      <div>
        <Paper zDepth={1} style={styles.paper}>
          <div style={styles.selectContainer}>
            <h3 style={styles.label}>Selecciona una empresa</h3>
            <SelectField
              style={styles.selectField}
              value={this.state.selectedCompany}
              onChange={this.handleCompanySelectChange}
              >
              {this.props.companies.map((company) => {
                return(<MenuItem key={company.id} value={company} primaryText={company.name} styles={styles.menuItem}/>)
              })}
            </SelectField>
          </div>
          {this.state.selectedCompany.deadlines.length > 0 ?
          <div>
            {this.state.selectedCompany.deadlines.map((deadline, i) => {
              return (
                <div key={deadline.id}>
                  <h3 style={styles.label}>Etapa de {stepToTitle[deadline.step]}</h3>
                  <h4 style={styles.dateContainer}>Inicio: <DatePicker
                    inputStyle={styles.dateInput}
                    container="inline"
                    mode="landscape"
                    onChange={(event, date)=> this.updateDate(date, i, 'start_date')}
                    minDate={deadline.step === 'postulation' ? this.state.now : new Date(this.state.data[i-1].deadline)}
                    value={new Date(this.state.data[i].start_date)}
                    dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
                  /></h4>
                <h4 style={styles.dateContainer}>Término: <DatePicker
                    inputStyle={styles.dateInput}
                    container="inline"
                    mode="landscape"
                    onChange={(event, date)=> this.updateDate(date, i, 'deadline')}
                    minDate={new Date(this.state.data[i].start_date)}
                    value={new Date(this.state.data[i].deadline)}
                    dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
                  /></h4>
                </div>
              );
            })}
          </div>:
          <h3 style={styles.label}>La empresa aún no define sus plazos</h3>
        }
        </Paper>
        <div style={styles.buttonContainer}>
          <PrimaryButton label='Cambiar plazos' onClick={this.changeDeadlines} />
        </div>
      </div>
    );
  }

  handleCompanySelectChange = (event, index, value) => {
    this.setState({
      selectedCompany: value,
      data: value.deadlines,
    });
  }

  updateDate = (date, i, key) => {
    var data = this.state.data;
    data[i][key] = date;
    this.setState({data: data});
  }

  changeDeadlines = () => {
    this.props.raiseLoading();
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });

    var data = this.state.data;
    for (var i = 0; i < data.length; i++) {
      if (new Date(this.state.data[i].start_date) >= new Date(this.state.data[i].deadline)) {
        this.props.raiseAlertOneButton('¡Error!', 'Hay fechas de término anteriores a las fechas de inicio')
        return;
      }
      if(i < 2 && (new Date(data[i]['start_date']) >= new Date(data[i+1]['start_date']) || new Date(data[i]['deadline']) >= new Date(data[i+1]['start_date']))){
        this.props.raiseAlertOneButton('¡Error!', 'Recuerda que las fechas de postulación deben ser anteriores a las de selección, y estas últimas anteriores a las de fichas')
        return;
      }
      if(i < 1 && (new Date(data[i]['start_date']) > new Date(data[i+2]['start_date']) || new Date(data[i]['deadline']) > new Date(data[i+2]['start_date']))){
        this.props.raiseAlertOneButton('¡Error!', 'Recuerda que las fechas de postulación deben ser anteriores a las de selección, y estas últimas anteriores a las de fichas')
        return;
      }
    }

    connection.patch(routes.portfolioDeadlines(this.state.selectedCompany.id), this.state.data)
    .then((response) => {
      this.props.raiseAlertOneButton('¡Éxito!', 'Has cambiado los plazos de la empresa sin problemas')
    })
    .catch((err) => {
      this.props.raiseAlertOneButton('¡Error!', 'Hubo un problema al cambiar los plazos de la empresa, intenta nuevamente')
    })
  }
}

export default ChangeCompanyDeadlines;



// WEBPACK FOOTER //
// ./src/components/administration/ChangeCompanyDeadlines.js